import React, { useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import '../StripePayment/StripePayment.css';
import '../../styles/login.css';
import ContactUsForm from './ContactUsForm';
import CloseIcon from '@mui/icons-material/Close';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

import LogoSvg from '../../assets/logo.svg';

function ContactUs() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  const handleSuccess = () => {
    // Success is now handled by ContactUsForm component
  };

  return (
    <div className={`login-body ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`} style={{ overflowX: 'hidden', overflowY: 'auto' }}>
      {/* Header with Logo, Title and Close Button */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: mode === 'dark' ? 'rgba(17, 17, 17, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`
      }}>
        {/* Logo on left */}
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
          <img src={LogoSvg} alt="Complimate Logo" style={{ height: 40, verticalAlign: 'middle' }} />
        </Link>
        
        {/* Title centered */}
        <h2 style={{
          margin: 0,
          fontSize: '24px',
          fontWeight: 700,
          color: mode === 'dark' ? '#26C3C0' : '#009391',
          fontFamily: "'Urbanist', Arial, sans-serif",
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap'
        }}>
          Contact Us
        </h2>
        
        {/* Close button on right */}
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            color: mode === 'dark' ? '#FFFFFF' : '#222222',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
            flex: '0 0 auto',
            marginLeft: 'auto'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = mode === 'dark' ? '#333' : '#f0f0f0';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          <CloseIcon style={{ fontSize: '24px' }} />
        </button>
      </div>

      <Container fluid className="contactus-container">
        <Row className="contact-layout-row">
          <Col xs={12} lg={5} className="contact-info-panel">
            <div className="contact-info-inner">
              <span className="contact-info-badge">We'd love to hear from you</span>
              <h1 className="contact-info-heading">Talk with the Complimate team</h1>
              <p className="contact-info-description">
                Need support, pricing guidance, or a tailored compliance walkthrough?
                Our specialists are ready to help you move fast and stay regulator-ready.
              </p>
              <div className="contact-info-card">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <PhoneInTalkIcon />
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Call us</span>
                    <a href="tel:1300322050" className="contact-info-link">1300 32 20 50</a>
                    <span className="contact-info-subtext">Mon – Fri, 8:30am – 6:00pm AEDT</span>
                  </div>
                </div>
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <EmailOutlinedIcon />
                  </div>
                  <div className="contact-info-content">
                    <span className="contact-info-label">Email</span>
                    <a href="mailto:support@complimate.com" className="contact-info-link">support@complimate.com</a>
                    <span className="contact-info-subtext">We respond within one business day</span>
                  </div>
                </div>
              </div>
              <div className="contact-info-footnote">
                Prefer speaking with a consultant? Book a complimentary discovery call
                and we’ll tailor Complimate to your obligations.
              </div>
            </div>
          </Col>

          <Col xs={12} lg={7} className="contact-form-panel">
            <div className="contact-form-wrapper">
              <div className="contact-form-header">
                <h2>Send us a message</h2>
                <p>Share a few details and we’ll route your request to the right compliance specialist.</p>
              </div>
              <ContactUsForm
                onSuccess={handleSuccess}
                submitLabel="Submit"
                secondaryFirst={true}
                secondaryAction={
                  <Button
                    variant="outline-secondary"
                    className="action-btn secondary-action"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </Button>
                }
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ContactUs;


